import { Component } from '@angular/core';
import { ModalController, Loading, ToastController, LoadingController, AlertController } from 'ionic-angular';
import { UserAddPage } from '../../pages/user-add/user-add';
import { UserUpdatePage } from '../../pages/user-update/user-update';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { WhereFilterOp } from '@firebase/firestore-types';
import { AdminProvider } from '../../providers/admin/admin';
import moment from 'moment';

interface myInterface {
  dob: number;
  calendar: [{
    complete: boolean;
    date: Date;
    fileReq: boolean;
    files: [{
      fullPath: string;
      name: string;
      path: string;
    }];
    notes: string;
    task: boolean;
    topic: string;
  }];
  company: string;
  name: string;
  ocupation: string;
  sex: string;
  status: number;
}

@Component({
  selector: 'users',
  templateUrl: 'users.html'
})
export class UsersComponent {
  activeTab = 0;
  itemSel: any;
  itemsCollection: AngularFirestoreCollection<myInterface>;
  items: myInterface[];
  loading: Loading;
  calendarSessions: any;

  constructor(public admin: AdminProvider, public afAuth: AngularFireAuth, public asf: AngularFirestore, public modalCtrl: ModalController, public toastCtrl: ToastController, public loadingCtrl: LoadingController, public alertCtrl: AlertController) {
    afAuth.auth.onAuthStateChanged(user => {
      this.itemsCollection = asf.collection("Users", ref => ref.where("coach", "==", user.uid).where("type", "==", 2).orderBy("uppercaseName","asc"));
      this.itemsCollection.snapshotChanges().subscribe((data) => {
        this.items = data.map((item) => {
          const data = item.payload.doc.data() as myInterface;
          const id = item.payload.doc.id;
          const coachData = this.DataCoach(item.payload.doc.data().coach);
          const numbers = this.asf.collection("Sessions").ref.where("idAlumno", "==", id).get().then(data => {
            return data.docs.length;
          });
          const lastSessions = this.asf.collection("Sessions").ref.where("idAlumno", "==", id).where("sessionDate", "<=", new Date()).orderBy("sessionDate", "desc").limit(1).get().then(data => {
            let ret: any;
            data.forEach(element => {
              ret = element;
            });
            if (ret && ret.sessionDate) {
              ret.id = ret.id;
              ret.sessionDate = ret.sessionDate;
              ret.sessionDate2 = this.stringDate(ret.sessionDate);
            }
            return ret;
          });
          const nextSessions = this.asf.collection("Sessions").ref.where("idAlumno", "==", id).where("sessionDate", ">=", new Date()).orderBy("sessionDate", "asc").limit(1).get().then(data => {
            let ret: any;
            data.forEach(element => {
              ret = element;
            });
            if (ret && ret.sessionDate) {
              ret.id = ret.id;
              ret.sessionDate = ret.sessionDate;
              ret.sessionDate2 = this.stringDate(ret.sessionDate);
            }
            return ret;
          });
          return { id, "numbers": numbers, "lastSessions": lastSessions, "nextSessions": nextSessions, "coachData": coachData, ...data }
        });
      });
    });
  }

  changeActiveTab(x) {
    if (this.activeTab == x) {
      this.activeTab = 0
    } else {
      this.activeTab = x;
    }
  }

  async DataCoach(idCoach): Promise<any> {
    let ret;
    await this.asf.doc("Users/" + idCoach).ref.get().then(data => {
      if (data.exists) {
        //if (data.exists && data.get('status') == 1) {
        ret = data.data();
      }
    });
    return ret;
  }

  presentAddModal() {
    let addModal = this.modalCtrl.create(UserAddPage);
    addModal.present();
  }

  presentConfirmDelete(id: string) {
    let alert = this.alertCtrl.create({
      title: 'Eliminar usuario',
      message: '¿Estas seguro de eliminar usuario?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Eliminar',
          handler: () => {
            this.deleteItem(id);
          }
        }
      ]
    });
    alert.present();
  }

  async deleteDb(idDocument) {
    const promise1: Promise<any> = this.deleteWhere("Sessions", "idAlumno", "==", idDocument);
    const promise2: Promise<any> = this.deleteWhere("Tasks", "idAlumno", "==", idDocument);
    const promise3: Promise<any> = this.asf.doc("Users/" + idDocument).delete();
    await Promise.all([promise1, promise2, promise3]);
  }

  deleteItem(idDocument: string) {
    this.presentLoadingCustom();
    this.afAuth.auth.currentUser.getIdToken(true).then((idToken) => {
      this.admin.deleteAccount(idToken, idDocument).toPromise().then((response) => {
        if (response['success'] == true) {
          this.deleteDb(idDocument).then(() => {
            this.loading.dismiss();
            this.presentToast('Eliminado correctamente');
          }).catch(error => {
            this.loading.dismiss();
            ////console.error(error);
            this.presentToast('Ha ocurrido un error');
          });
        } else {
          this.loading.dismiss();
          ////console.error(response);
          this.presentToast('Ha ocurrido un error');
        }
      }).catch(error => {
        this.loading.dismiss();
        ////console.error(error);
        this.presentToast('Ha ocurrido un error');
      });
    }).catch(error => {
      this.loading.dismiss();
      ////console.error(error);
      this.presentToast('Ha ocurrido un error');
    });
  }

  presentLoadingCustom() {
    this.loading = this.loadingCtrl.create({
      content: `Loading`
    });
    this.loading.present();
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  async deleteWhere(collection: string, field: string, operator: WhereFilterOp, value: any) {
    let query = this.asf.collection(collection).ref.where(field, operator, value).get();
    let batch = this.asf.firestore.batch();
    await query.then(async data => {
      data.docs.forEach(element => {
        batch.delete(element.ref);
      });
      await batch.commit();
    });
  }

  updateItem(item: any) {
    let modal = this.modalCtrl.create(UserUpdatePage, { "item": item });
    modal.present();
  }

  stringDate(date: any): string {
    moment.locale("es");
    return moment(date).format("lll");
  }
  selectItem(x) {
    this.itemSel = x;
    this.changeActiveTab(this.activeTab);
  }
}



// WEBPACK FOOTER //
// ./src/components/users/users.ts